import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const QuotaEndedPopup = loadAsyncComponent(() => import('./Container'), 'popup');
